export function LegalModal({ title, onClose, children }) {
  return (
    <div className="bv-modal-overlay" onClick={onClose} role="presentation">
      <div className="bv-modal bv-modal-wide" role="dialog" aria-modal="true" aria-labelledby="legal-title" onClick={(e) => e.stopPropagation()}>
        <div className="bv-legal-head">
          <h2 id="legal-title">{title}</h2>
          <button type="button" className="bv-modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="bv-legal-body">{children}</div>
      </div>
    </div>
  );
}

export function PrivacyPolicy({ onClose }) {
  return (
    <LegalModal title="Privacy Policy" onClose={onClose}>
      <p className="bv-legal-meta">Effective January 2026 · Black Vanilla Technologies</p>
      <h3>Information we collect</h3>
      <p>When you submit the contact form we collect your name, business email, company name, and message so we can respond. We do not sell this information.</p>
      <h3>How we use it</h3>
      <p>Contact information is used to reply to your inquiry and discuss Black Vanilla Technologies products. We do not use it for advertising.</p>
      <h3>civil3d</h3>
      <p>The civil3d product (civil3d.app) may process spatial data as part of reconstruction and related workflows. Data-handling details will be provided to customers as the product matures.</p>
      <h3>Cookies &amp; analytics</h3>
      <p>blackvanilla.ai does not use advertising or tracking cookies. Firebase Hosting may collect standard server logs as part of normal infrastructure.</p>
      <h3>Contact</h3>
      <p>Privacy queries: contactus@blackvanilla.ai</p>
    </LegalModal>
  );
}

export function TermsOfService({ onClose }) {
  return (
    <LegalModal title="Terms of Service" onClose={onClose}>
      <p className="bv-legal-meta">Effective January 2026 · Black Vanilla Technologies</p>
      <div className="bv-callout">
        Research &amp; development notice: civil3d and related Black Vanilla Technologies products are in active development. Outputs must not be used as the sole basis for structural, legal, or safety-critical decisions without independent professional verification.
      </div>
      <h3>1. Acceptance</h3>
      <p>By accessing blackvanilla.ai or civil3d.app you agree to these terms.</p>
      <h3>2. Nature of the technology</h3>
      <p>civil3d is a spatial intelligence product in active development. Outputs may contain errors. Black Vanilla Technologies makes no warranty of accuracy or fitness for a particular purpose.</p>
      <h3>3. Limitation of liability</h3>
      <p>To the maximum extent permitted by law, Black Vanilla Technologies is not liable for damages arising from use of this website or the civil3d product.</p>
      <h3>4. Intellectual property</h3>
      <p>Site content, the civil3d product, related software, and brand are intellectual property of Black Vanilla Technologies.</p>
      <h3>5. Governing law</h3>
      <p>Governed by the laws of India. Disputes are subject to the courts of Delhi, India.</p>
    </LegalModal>
  );
}
